import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4.929 9C3.119 10.5 2 12 2 12s4.477 6 10 6a8.2 8.2 0 0 0 2-.254M10.016 6.25A8.2 8.2 0 0 1 12 6c5.523 0 10 6 10 6s-1.12 1.5-2.929 3M10.157 10.31a2.5 2.5 0 0 0 3.593 3.475M19.5 19.5l-15-15" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }